import { ButtonPrimary, ButtonSecondary } from '@components/button';

import { DrawerFormFooterProps } from './drawer-form-footer.type';

/**
 * Flat fixed footer for the offer-chassis form drawers: a top-bordered row with a secondary
 * (discard) and a primary submit action. The primary is always `type='submit'` — `DrawerFormLayout`
 * is a `<form>` and every drawer form saves through it (Enter-to-save, B2B-1950).
 */
export const DrawerFormFooter = ({
  onDiscard,
  discardLabel,
  primaryLabel,
  primaryDisabled,
}: DrawerFormFooterProps): JSX.Element => (
  <footer className='flex justify-end gap-3 border-t border-extra-soft p-4 xs:px-10 xs:py-6'>
    <ButtonSecondary onClick={onDiscard}>{discardLabel}</ButtonSecondary>
    <ButtonPrimary type='submit' disabled={primaryDisabled}>
      {primaryLabel}
    </ButtonPrimary>
  </footer>
);
